<template>
  <b-row>
    <b-col v-for="(field, index) in formSpecs.fields" :key="index" v-bind="field.layout">
      <b-form-group>
        <label v-if="field.outsideLabel" class="label-size-lg" :class="field.class">{{ field.label }} </label>
        <router-link
          v-if="field.link"
          :to="{ name: field.link.name, params: field.link.params }"
          v-bind="field.link.customAttributes"
        >
          <component
            :is="field.component"
            :ref="field.model"
            v-model="form[field.model]"
            :label="field.label"
            v-bind="field.customAttributes"
            :class="field.class"
            :options="field.options"
            :model-select="field.options"
            :input-type="field.inputType"
            :submitted="submitted"
            :invalid="$v.form[field.model].$error"
            :required="'required' in $v.form[field.model] && !$v.form[field.model].required"
            :email="'email' in $v.form[field.model] && !$v.form[field.model].email"
            :numeric="'numeric' in $v.form[field.model] && !$v.form[field.model].numeric"
            :url="'url' in $v.form[field.model] && !$v.form[field.model].url"
            :min-length="'minLength' in $v.form[field.model] && !$v.form[field.model].minLength"
            :max-length="'maxLength' in $v.form[field.model] && !$v.form[field.model].maxLength"
            :decimal="'decimal' in $v.form[field.model] && !$v.form[field.model].decimal"
            :min-value="'minValue' in $v.form[field.model] && !$v.form[field.model].minValue"
            :max-value="'maxValue' in $v.form[field.model] && !$v.form[field.model].maxValue"
          >
            <div v-if="field.insideLabel">
              {{ field.label }}
            </div>
          </component>
        </router-link>
        <component
          :is="field.component"
          v-else
          :ref="field.model"
          v-model="form[field.model]"
          :label="field.label"
          v-bind="field.customAttributes"
          :class="field.class"
          :options="field.options"
          :model-select="field.options"
          :input-type="field.inputType"
          :submitted="submitted"
          :invalid="$v.form[field.model].$error"
          :required="'required' in $v.form[field.model] && !$v.form[field.model].required"
          :email="'email' in $v.form[field.model] && !$v.form[field.model].email"
          :numeric="'numeric' in $v.form[field.model] && !$v.form[field.model].numeric"
          :url="'url' in $v.form[field.model] && !$v.form[field.model].url"
          :min-length="'minLength' in $v.form[field.model] && !$v.form[field.model].minLength"
          :max-length="'maxLength' in $v.form[field.model] && !$v.form[field.model].maxLength"
          :decimal="'decimal' in $v.form[field.model] && !$v.form[field.model].decimal"
          :min-value="'minValue' in $v.form[field.model] && !$v.form[field.model].minValue"
          :max-value="'maxValue' in $v.form[field.model] && !$v.form[field.model].maxValue"
        >
          <div v-if="field.insideLabel">
            {{ field.label }}
          </div>
        </component>
        <div v-if="field.subForm">
          <h-f-auto-form
            v-if="field.subForm.hasOwnProperty(form[field.model])"
            ref="childForm"
            v-model="form"
            :form-specs="field.subForm[form[field.model]]"
          />
        </div>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
/*
  Auto-form component
    - Generate form from formSpecs
      This component is used to generate form from formSpecs object.
      formSpecs object is defined in the parent component.
      formSpecs object contains the following properties:
        - fields: array of fields
          Each field contains the following properties:
            - component: string
              The component to use for the field
            - model: string
              The model of the field
            - label: string
              The label of the field
            - inputType: string
              The input type of the field
            - validation: object
              The validation of the field
            - customAttributes: object
              The custom attributes of the field
            - layout: object
              The layout of the field
        - ressourceClass: object from sdk
          The ressource class of the form
        - successCreateMessage: string
          The success message to display when the form is submitted (creation) with success
        - successEditMessage: string
          The success message to display when the form is submitted (edition) with success
*/

import { FunctionHelpers } from '@/node-sdk'

export default {
  name: 'auto-form',
  props: {
    formSpecs: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.value,
      submitted: false,
      modify: false,
      childrenRule: 0,
    }
  },
  validations() {
    const validation = {
      form: {},
    }
    this.formSpecs.fields.forEach((field) => {
      if (field.validation) {
        validation.form[field.model] = field.validation
      }
    })
    return validation
  },
  watch: {
    form() {
      this.$emit('input', this.form)
    },
    value() {
      this.form = this.value
    },
  },
  methods: {
    initForm(modify, instance) {
      this.submitted = false
      this.form = instance
      this.modify = modify
      if (!modify) {
        this.form = this.value
      } else {
        this.form = instance
      }
    },
    isInvalidChild() {
      // Validate child form
      if (this.$refs.childForm) {
        this.$refs.childForm[0].submitting()
        this.$refs.childForm[0].$v.$touch()
        return this.$refs.childForm[0].$v.$invalid
      }
      return false
    },
    isInvalid() {
      // Validate form
      this.submitting()
      this.$v.$touch()
      return this.$v.$invalid
    },
    submitting() {
      this.submitted = true
    },
    async create() {
      this.formSpecs.fields.forEach(async (field) => {
        if (field.component === 'h-f-model-multi-taggable') {
          await this.$ref[field.model].createNewOption()
        }
      })
      if (this.isInvalid() || this.isInvalidChild()) {
        FunctionHelpers.formErrorModal()
      } else {
        // Add additionnals params to patch
        const resp = await this.formSpecs.ressourceClass.create(this.form)
        this.$toast.open(FunctionHelpers.getToastSuccessOptions(this.formSpecs.successCreateMessage))
        this.$emit('create', resp)
        this.submitted = false
      }
    },
    async edit() {
      if (this.isInvalid() || this.isInvalidChild()) {
        FunctionHelpers.formErrorModal()
      } else {
        // Add additionnals params to patch
        const resp = await this.formSpecs.ressourceClass.patch(this.form.id, { data: { ...this.form } })
        this.$toast.open(FunctionHelpers.getToastSuccessOptions(this.formSpecs.successEditMessage))
        this.$emit('edit', resp)
        this.submitted = false
      }
    },
    async submit() {
      this.submitting()
      if (!this.modify) {
        await this.create()
      } else {
        await this.edit()
      }
    },
  },
}
</script>

<style scoped></style>
